import { useDesignSystem } from 'contexts/design-system'
import PaginationEui from './pagination.eui'
import PaginationMui from './pagination.mui'
import { PaginationProps } from './types'

export type { PaginationProps } from './types'

export default function Pagination( props: PaginationProps ) {
	const designSystem = useDesignSystem()

	if ( props.pageCount < 1 ) {
		return null
	}

	return designSystem === 'mui'
		? <PaginationMui {...props} />
		: <PaginationEui {...props} />
}
